import React from 'react'

export const Typography = ({ tag = 'div', children, ...props }) => {

  if (!children) return;

  const Tag = tag

  // console.log(`Typography`, typeof children)

  if (typeof children === "string") {
    return <Tag {...props} 
      dangerouslySetInnerHTML={{
        __html: children,
      }} />
  } else {
    return <Tag {...props}>{children}</Tag>
  }
}

Typography.Div = Typography